import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { Ticket } from "../page/ticket/ticket";
import { Usuario } from "../page/usuario/usuario";
import { NotaTicket, Page } from "../page/ticket/nota";

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  apiURL: string = environment.apiBaseUrl + 'ticket';

  constructor(private http: HttpClient) { }

  getById(id: number) {
    return this.http.get<any>(`${this.apiURL}/${id}`);
  }
  save(ticket: Ticket): Observable<Ticket> {
    return this.http.post<Ticket>(this.apiURL, ticket);
  }

  list(page: number, size: number): Observable<any> {
    const params = new HttpParams().set('page', page.toString()).set('size', size.toString());
    return this.http.get<any>(`${this.apiURL}?${params.toString()}`);
  }

  consultar(filtros: {
    id?: number | null;
    segmento?: string | null;
    parceiroId?: number | null;
    prioridade?: string | null;
    tipo?: string | null;
    atribuidoId?: number | null;
    status?: string | null;
    assunto?: string | null;
  }, page: number, size: number): Observable<any> {
    let params = new HttpParams()
      .set('page', page.toString())
      .set('size', size.toString());
    if (filtros.id != null) {
      params = params.set('id', filtros.id.toString());
    }
    if (filtros.segmento) {
      params = params.set('segmento', filtros.segmento);
    }
    if (filtros.parceiroId != null) {
      params = params.set('parceiroId', filtros.parceiroId.toString());
    }
    if (filtros.prioridade) {
      params = params.set('prioridade', filtros.prioridade);
    }
    if (filtros.tipo) {
      params = params.set('tipo', filtros.tipo);
    }
    if (filtros.atribuidoId != null) {
      params = params.set('atribuidoId', filtros.atribuidoId.toString());
    }
    if (filtros.status) {
      params = params.set('status', filtros.status);
    }
    if (filtros.assunto?.trim()) {
      params = params.set('assunto', filtros.assunto.trim());
    }
    return this.http.get<any>(`${this.apiURL}/consulta`, { params });
  }
  update(ticket: Ticket): Observable<any> {
    return this.http.put<Ticket>(`${this.apiURL}/${ticket.id}`, ticket);
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiURL}/${id}`);
  }

  buscarComFiltros(parametro: any, tipoFiltro: any, page: number, size: number): Observable<any> {
    let params = new HttpParams()
      .set('page', page)
      .set('size', size)
      .set('parametro', parametro)
      .set('tipoFiltro', tipoFiltro)
      ;
    return this.http.get<any>(`${this.apiURL}/consultar/${params}`);
  }

  buscarUsuariosAtribuicao(): Observable<Usuario[]> {
    return this.http.get<Usuario[]>(`${this.apiURL}/usuariosAtribuicao`);
  }

  adicionarComentario(ticketId: number, comentario: NotaTicket, page = 0, size = 5): Observable<Page<NotaTicket>> {
    return this.http.post<Page<NotaTicket>>(
      `${this.apiURL}/comentarios/${ticketId}?page=${page}&size=${size}`,
      comentario
    );
  }

  listarComentarios(ticketId: number, page = 0, size = 5): Observable<Page<NotaTicket>> {
    let params = new HttpParams()

      .set('page', page)
      .set('size', size);
    return this.http.get<Page<NotaTicket>>(
      `${this.apiURL}/listarComentarios/${ticketId}`,
      { params }
    );
  }

  iniciarCronometro(id: number): Observable<Ticket> {
    return this.http.post<Ticket>(`${this.apiURL}/${id}/cronometro/iniciar`, {});
  }

  pararCronometro(id: number): Observable<Ticket> {
    return this.http.post<Ticket>(`${this.apiURL}/${id}/cronometro/parar`, {});
  }

  montarGraficoTicketStatus(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/graficoTicketStatus`);
  }

  montarGraficoTicketResponsavel(): Observable<any>{
    return this.http.get<any>(`${this.apiURL}/graficoTicketResponsavel`);
  }

}